export class S3KeyResolver {
  async resolveActualKey(uploadPath: string): Promise<string> {
    const pathParts = uploadPath.split("/");
    const folderPath = pathParts.slice(0, -1).join("/");

    const { list } = await import("aws-amplify/storage");
    const listResult = await list({ path: `${folderPath}/` });

    const recentFile = listResult.items
      .filter((item) => item.path.includes(folderPath))
      .sort(
        (a, b) =>
          new Date(b.lastModified || 0).getTime() -
          new Date(a.lastModified || 0).getTime(),
      )[0];

    return recentFile?.path || uploadPath;
  }
}
